"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeaderInfo = void 0;
const next12_utils_types_1 = require("@gcloud-npm/next12.utils.types");
const next12_utils_request_1 = __importDefault(require("@gcloud-npm/next12.utils.request"));
const next12_utils_front_sonda_1 = __importDefault(require("@gcloud-npm/next12.utils.front-sonda"));
const next12_utils_build_environments_1 = require("@gcloud-npm/next12.utils.build-environments");
const getHeaderInfo = (context, build = true) => {
    const familyApi = "bucket";
    const PATH_GET_HEADER_INFO = "/static/json/header/header.json";
    const errorDetected = (sonda) => {
        sonda.errorMessage({
            info: `Ha fallado la petición al json: ${sonda.processName}`,
        });
    };
    const myFrontSonda = new next12_utils_front_sonda_1.default({
        processName: "MISCELLANEOUS.GET_HEADER_INFO",
        context,
        filePath: "sagas/header",
    });
    const { bucket: connectionData } = context.environment;
    const { endpoint: host } = connectionData;
    const URL_API = `${host}${PATH_GET_HEADER_INFO}`;
    try {
        const headers2Use = (0, next12_utils_build_environments_1.calculateHeaderParams)(build, familyApi, context);
        const request = new next12_utils_request_1.default({
            method: next12_utils_types_1.MethodType.GET,
            endpoint: URL_API,
            onError: () => errorDetected(myFrontSonda),
            onTimeout: () => errorDetected(myFrontSonda),
            headers: Object.assign({}, headers2Use),
        });
        return request.makeRequest();
    }
    catch (err) {
        myFrontSonda.errorMessage({
            error: err,
            info: "Ha fallado js durante la invocación al json",
        });
        return null;
    }
};
exports.getHeaderInfo = getHeaderInfo;
exports.default = exports.getHeaderInfo;
//# sourceMappingURL=getHeaderInfoPromise.js.map